import './templates/pages/ebanking-page.js';
import './templates/components/magnolia-fallback-component.js';
import './templates/components/editable-button-bar.js';
import '../../src/components/@e-banking/components/e-banking-section-headline/e-banking-section-headline.js';
import './templates/components/editable-notification.js';
import './templates/components/editable-rich-text.js';
import './templates/components/editable-picture.js';
import './templates/components/editable-accordion-group.js';
import './templates/components/editable-accordion-item.js';
import './templates/components/editable-tab-group.js';
import './templates/components/editable-tab-item.js';
import './templates/components/editable-slider-group.js';
import './templates/components/editable-slider-item.js';
import './templates/components/editable-icon-list.js';
import './templates/components/editable-data-table.js';
import './templates/components/editable-bento.js';

const config = {
    componentMappings: {
        'migrosbank-website:pages/e-banking/e-banking-content': 'editable-e-banking-page',
        'migrosbank-website:components/e-banking/e-banking-accordion-group': 'editable-accordion-group',
        'migrosbank-website:components/e-banking/e-banking-accordion-item': 'editable-accordion-item',
        'migrosbank-website:components/e-banking/e-banking-button-bar': 'editable-button-bar',
        'migrosbank-website:components/e-banking/e-banking-section-headline': {
            tagName: 'mb-e-banking-section-headline',
            spread: true,
        },
        'migrosbank-website:components/e-banking/e-banking-rich-text': 'editable-rich-text',
        'migrosbank-website:components/e-banking/e-banking-picture': 'editable-picture',
        'migrosbank-website:components/e-banking/e-banking-notification': 'editable-notification',
        'migrosbank-website:components/e-banking/e-banking-icon-list': 'editable-icon-list',
        'migrosbank-website:components/e-banking/e-banking-data-table': 'editable-data-table',
        'migrosbank-website:components/e-banking/e-banking-tab-group': 'editable-tab-group',
        'migrosbank-website:components/e-banking/e-banking-tab-item': 'editable-tab-item',
        'migrosbank-website:components/e-banking/e-banking-slider-group': 'editable-slider-group',
        'migrosbank-website:components/e-banking/e-banking-slider-item': 'editable-slider-item',
        'migrosbank-website:components/e-banking/e-banking-bento': 'editable-bento',
    },
};

export default config;
